export const NAMESPACE = 'file';

export const SELENIUM_LOGFILE_NAME = 'log.json';
export const ESPRESSO_LOGFILE_NAME = 'native-log.json';

export const STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  LOADING: 'LOADING',
};

export const EDS_SPECIFIC_FILENAMES = ['console.json'];

export const RDC_SPECIFIC_FILENAMES = ['appium.log', 'commands.json', 'device.log'];
